export default class OperationFranchises {
  constructor (initialData = {},) {
    const {
      franchise_id,
      dm_investment,
      consultant,
      products,
    } = initialData;

    this.franchise_id = franchise_id || null;
    this.dm_investment = dm_investment || false;
    this.consultant = consultant;
    this.products = products || [];
  }
}
